"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var react_1 = __importStar(require("react"));
var firebase = __importStar(require("firebase/app"));
var styles_1 = require("@material-ui/core/styles");
var core_1 = require("@21st-night/core");
var core_2 = require("@material-ui/core");
var lab_1 = require("@material-ui/lab");
var RichTextEditor_1 = __importDefault(require("../../RichTextEditor"));
var Button_1 = __importDefault(require("../../Button"));
exports.useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        root: {
            position: 'relative',
            backgroundColor: '#F0F4F8',
            borderRadius: theme.shape.borderRadius,
            padding: theme.spacing(1),
            marginBottom: theme.spacing(2),
        },
        image: {
            maxWidth: '100%',
        },
        progressContainer: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            color: '#FFF',
        },
        progressRing: {
            color: '#FFF',
            marginBottom: theme.spacing(2),
        },
    });
});
var EditorExtractTextDialog = function (_a) {
    var card = _a.card, deck = _a.deck, property = _a.property, onClickCancel = _a.onClickCancel, onSuccess = _a.onSuccess, other = __rest(_a, ["card", "deck", "property", "onClickCancel", "onSuccess"]);
    var classes = exports.useStyles();
    var _b = core_1.useFirebase(), userId = _b.userId, db = _b.db;
    var value = core_1.getJSONValue(card[property]);
    var image = core_1.getFirstImage(value) || { id: null };
    var imageIndex = value.findIndex(function (element) { return element.id === image.id; }) || 0;
    value = __spreadArray(__spreadArray(__spreadArray([], __read(value.slice(0, imageIndex))), __read(core_1.getJSONValue(card[property + "OcrText"]))), __read(value.slice(imageIndex + 1)));
    var _c = __read(react_1.useState(value), 2), text = _c[0], setText = _c[1];
    function onClickSave() {
        return __awaiter(this, void 0, void 0, function () {
            var deckUpdate, newCard;
            var _a, _b;
            return __generator(this, function (_c) {
                if (card.deck === deck.id) {
                    db.collection('cards')
                        .doc(card.id)
                        .update((_a = {},
                        _a[property + "OcrCompleted"] = true,
                        _a[property + "OcrText"] = firebase.firestore.FieldValue.delete(),
                        _a["" + property] = JSON.stringify(text),
                        _a));
                }
                else {
                    deckUpdate = (_b = {},
                        _b["cards." + card.id + "." + property + "OcrCompleted"] = true,
                        _b[property] = JSON.stringify(text),
                        _b);
                    if (property === 'question') {
                        deckUpdate["cards." + card.id + ".questionEdited"] = true;
                    }
                    db.collection('users')
                        .doc(userId)
                        .collection('decks')
                        .doc(deck.id)
                        .update(deckUpdate);
                }
                newCard = card;
                newCard[property] = JSON.stringify(text);
                newCard[property + "OcrCompleted"] = true;
                if (property === 'question') {
                    newCard.questionEdited = true;
                }
                onSuccess(newCard);
                return [2 /*return*/];
            });
        });
    }
    return (react_1.default.createElement(core_2.Dialog, __assign({ fullWidth: true, maxWidth: "md" }, other),
        react_1.default.createElement(core_2.DialogContent, null,
            react_1.default.createElement(core_2.Grid, { container: true, spacing: 4 },
                image && (react_1.default.createElement(core_2.Grid, { item: true, xs: 12, sm: 6, style: { position: 'relative' } },
                    react_1.default.createElement("img", { className: classes.image, alt: "", src: image.url }))),
                react_1.default.createElement(core_2.Grid, { item: true, xs: 12, sm: 6 },
                    react_1.default.createElement(lab_1.Alert, { severity: "info" }, "The image will be replaced with the text below."),
                    react_1.default.createElement(RichTextEditor_1.default, { toolbar: [
                            'bold',
                            'underline',
                            'italic',
                            'strikethrough',
                            'tex',
                            'block-formatting',
                            'numbered-list',
                            'bulleted-list',
                        ], initialValue: value, onChange: function (v) { return setText(v); } })))),
        react_1.default.createElement(core_2.DialogActions, null,
            react_1.default.createElement(Button_1.default, { variant: "text", onClick: onClickCancel }, "Cancel"),
            react_1.default.createElement(Button_1.default, { variant: "outlined", onClick: onClickSave }, "Update"))));
};
exports.default = EditorExtractTextDialog;
//# sourceMappingURL=CardOcr.js.map